export enum ArticleScope {
  WALL = 1,
  SLAB = 2,
  PLATFORM = 3,
}
